<template>
  <b-modal
    v-model="modal"
    dialog-class="!max-w-[600px]"
    content-class="rounded-[10px]"
    body-class="!px-[64px] !py-[48px]"
    hide-header
    hide-footer
    centered
    lazy
  >
    <i
      class="fa fa-close z-[50] absolute top-[15px] right-[17px] text-[16px] text-[#6E747A] transition cursor-pinter hover:opacity-60"
      @click="modal = false"
    />

    <div class="w-full flex flex-col items-center gap-y-[32px] font-[ProximaNova]">
      <div class="max-w-[600px] w-full flex flex-col items-center gap-[16px]">
        <h3 class="text-[32px] leading-[36px] font-[700] text-[#000000] mb-0">
          {{ update ? 'Update Payment Method' : 'Add New Payment Method' }}
        </h3>
      </div>

      <b-form
        class="w-full flex flex-col"
        @submit.prevent.once="submit"
      >
        <StripeElements
          v-slot="{ elements }"
        >
          <b-form-group
            label="Card Number"
            label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
            class="mb-2.5"
          >
            <div class="flex h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded">
              <StripeElement
                type="cardNumber"
                :elements="elements"
                class="w-full h-[150%]"
                :options="{
                  style: {
                    base: {
                      fontSize: '1rem',
                      color: '#000000',
                      fontFamily: 'ProximaNova, sans-serif'
                    }
                  },
                  showIcon: true,
                  disableLink: true
                }"
                @stripe-element="card = $event"
              />
            </div>
          </b-form-group>

          <div class="flex items-center gap-[.75rem]">
            <b-form-group
              label="Expiry Date"
              label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
              class="mb-2.5"
            >
              <div class="flex w-[5rem] h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded">
                <StripeElement
                  type="cardExpiry"
                  :elements="elements"
                  class="w-full h-[150%]"
                  :options="{
                    style: {
                      base: {
                        fontSize: '1rem',
                        color: '#000000',
                        fontFamily: 'ProximaNova, sans-serif'
                      }
                    }
                  }"
                />
              </div>
            </b-form-group>

            <b-form-group
              label="CVC"
              label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
              class="mb-2.5"
            >
              <div class="flex items-center gap-[.75rem]">
                <div class="flex w-[4rem] h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded">
                  <StripeElement
                    type="cardCvc"
                    :elements="elements"
                    class="w-full h-[150%]"
                    :options="{
                      style: {
                        base: {
                          fontSize: '1rem',
                          color: '#000000',
                          fontFamily: 'ProximaNova, sans-serif'
                        }
                      }
                    }"
                  />
                </div>

                <svg
                  width="31"
                  height="27"
                  viewBox="0 0 31 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.493 0.517578H1.50294C0.674223 0.517578 0 1.19003 0 2.01658V19.9983C0 20.8248 0.674223 21.4972 1.50294 21.4972H4.59037C4.84113 21.4972 5.04442 21.2945 5.04442 21.0444C5.04442 20.7942 4.84113 20.5915 4.59037 20.5915H1.50294C1.17494 20.5915 0.908086 20.3254 0.908086 19.9983V8.49485H30.0879V19.9983C30.0879 20.3254 29.8211 20.5915 29.4931 20.5915H29.1624C29.4065 19.8179 29.5384 18.9951 29.5384 18.1421C29.5384 16.9805 29.2987 15.8576 28.8261 14.8047C28.7237 14.5765 28.4549 14.4743 28.2261 14.5764C27.9972 14.6787 27.8948 14.9466 27.9972 15.1748C28.4173 16.1106 28.6303 17.1089 28.6303 18.1421C28.6303 19.7815 28.0832 21.2956 27.1619 22.513H15.5211C14.5998 21.2956 14.0527 19.7815 14.0527 18.1421C14.0527 14.1336 17.3225 10.8725 21.3415 10.8725C23.6134 10.8725 25.7153 11.9018 27.1083 13.6964C27.2619 13.8941 27.547 13.9302 27.7452 13.7773C27.9435 13.6242 27.9798 13.3398 27.8263 13.142C26.2601 11.1241 23.8965 9.96681 21.3415 9.96681C16.8217 9.96681 13.1446 13.6343 13.1446 18.1422C13.1446 18.9952 13.2765 19.818 13.5206 20.5916H6.2147C5.96394 20.5916 5.76065 20.7943 5.76065 21.0445C5.76065 21.2947 5.96394 21.4974 6.2147 21.4974H13.8671C15.1565 24.3436 18.0286 26.3176 21.3415 26.3176C24.6529 26.3176 27.5259 24.3448 28.8159 21.4974H29.493C30.3217 21.4974 30.9959 20.8249 30.9959 19.9984V2.01658C30.996 1.19003 30.3218 0.517578 29.493 0.517578ZM16.333 23.4187H26.35C25.0431 24.6533 23.2795 25.4118 21.3415 25.4118C19.4035 25.4118 17.64 24.6533 16.333 23.4187ZM0.908086 7.58915V5.73239H23.6789C23.9298 5.73239 24.133 5.52969 24.133 5.27954C24.133 5.02938 23.9298 4.82669 23.6789 4.82669H0.908086V2.01658C0.908086 1.68944 1.17494 1.42328 1.50294 1.42328H29.4931C29.8211 1.42328 30.0879 1.68944 30.0879 2.01658V4.82669H25.3639C25.113 4.82669 24.9098 5.02938 24.9098 5.27954C24.9098 5.52969 25.113 5.73239 25.3639 5.73239H30.0879V7.58915H0.908086Z"
                    fill="#747E8C"
                  />
                  <path
                    d="M10.999 17.9939C11.9752 17.5275 12.5127 16.868 12.5127 16.137C12.5127 15.406 11.9752 14.7465 10.999 14.2801C10.1292 13.8646 8.98277 13.6357 7.77102 13.6357C6.55927 13.6357 5.41284 13.8646 4.54301 14.2801C3.56682 14.7465 3.0293 15.406 3.0293 16.137C3.0293 16.868 3.56688 17.5275 4.54301 17.9939C5.41284 18.4094 6.55921 18.6383 7.77102 18.6383C8.98283 18.6383 10.1292 18.4094 10.999 17.9939ZM3.93738 16.137C3.93738 15.779 4.3011 15.3999 4.93531 15.0969C5.68514 14.7387 6.69221 14.5414 7.77102 14.5414C8.84982 14.5414 9.85689 14.7388 10.6067 15.0969C11.2409 15.4 11.6047 15.779 11.6047 16.137C11.6047 16.495 11.2409 16.874 10.6067 17.1771C9.85689 17.5353 8.84982 17.7326 7.77102 17.7326C6.69221 17.7326 5.68514 17.5352 4.93531 17.1771C4.3011 16.8741 3.93738 16.495 3.93738 16.137Z"
                    fill="#747E8C"
                  />
                  <path
                    d="M18.2698 16.6606C18.4461 16.6606 18.616 16.7123 18.7611 16.8101C18.9688 16.9501 19.2512 16.8956 19.3915 16.6884C19.5319 16.4812 19.4773 16.1996 19.2695 16.0597C18.9737 15.8602 18.628 15.7549 18.2698 15.7549C17.2842 15.7549 16.4824 16.5546 16.4824 17.5376C16.4824 18.5205 17.2842 19.3202 18.2698 19.3202C18.667 19.3202 19.0246 19.1893 19.3034 18.9416C19.358 18.8932 19.4099 18.8398 19.4577 18.7829C19.6188 18.5913 19.5937 18.3057 19.4016 18.145C19.2095 17.9842 18.9231 18.0093 18.762 18.201C18.7424 18.2242 18.7215 18.2458 18.6997 18.2651C18.588 18.3643 18.4434 18.4145 18.2698 18.4145C17.7849 18.4145 17.3905 18.0211 17.3905 17.5376C17.3905 17.054 17.785 16.6606 18.2698 16.6606Z"
                    fill="#747E8C"
                  />
                  <path
                    d="M21.9623 16.0701L21.4573 17.5862L20.926 16.0595C20.8439 15.8232 20.585 15.6978 20.3482 15.7802C20.1114 15.8621 19.986 16.1202 20.0682 16.3565L20.9809 18.9793C21.0538 19.1838 21.2482 19.3205 21.4655 19.3205C21.4666 19.3205 21.4678 19.3205 21.469 19.3204C21.6877 19.319 21.8819 19.1792 21.9534 18.9696L22.8241 16.3556C22.9032 16.1182 22.7743 15.8619 22.5364 15.7831C22.2986 15.7042 22.0413 15.8327 21.9623 16.0701Z"
                    fill="#747E8C"
                  />
                  <path
                    d="M25.3159 16.0701L24.8109 17.5862L24.2795 16.0595C24.1974 15.8232 23.9385 15.6978 23.7018 15.7802C23.4649 15.8622 23.3395 16.1202 23.4217 16.3565L24.3345 18.9793C24.4073 19.1838 24.6017 19.3205 24.819 19.3205C24.8202 19.3205 24.8214 19.3205 24.8225 19.3204C25.0412 19.319 25.2355 19.1792 25.307 18.9696L26.1777 16.3556C26.2568 16.1182 26.128 15.8619 25.8899 15.7831C25.6522 15.7042 25.395 15.8327 25.3159 16.0701Z"
                    fill="#747E8C"
                  />
                </svg>
              </div>
            </b-form-group>
          </div>
        </StripeElements>

        <b-form-group
          class="w-full"
          label="Name on Card"
          label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
        >
          <b-input
            v-model="form.name"
            v-validate="`required`"
            name="name"
            :class="{'is-invalid': errors.has('name') ? true : null}"
            class="flex h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded"
            autocomplete="cc-name"
            x-autocompletetype="cc-name"
          />
        </b-form-group>

        <div class="w-full flex items-end">
          <b-form-group
            class="w-[264px]"
            label="Country"
            label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
          >
            <country-select
              v-model="form.country"
              v-validate="`required`"
              name="country"
              :class="{'is-invalid': errors.has('country') ? true : null}"
              class="flex h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded"
              autocomplete="billing country"
              x-autocompletetype="billing country"
              iso
            />
          </b-form-group>

          <b-form-group
            class="w-[128px] ml-[20px]"
            label="Zip Code"
            label-class="text-[.875rem] leading-[1.25rem] font-[500] text-[#363636]"
          >
            <b-input
              v-model="form.zip_code"
              v-validate="`required`"
              name="zip_code"
              :class="{'is-invalid': errors.has('zip_code') ? true : null}"
              class="flex h-[2.5rem] px-[0.625rem] py-[0.875rem] border border-[#D0D5DD] items-center bg-white sh shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] rounded"
              autocomplete="billing postal-code"
              x-autocompletetype="billing postal-code"
            />
          </b-form-group>
        </div>

        <b-form-group
          v-if="!setPrimary"
          class="w-full"
        >
          <b-form-checkbox v-model="form.main">
            <div class="translate-y-[-.5rem]">
              Set as primary payment method
            </div>
          </b-form-checkbox>
        </b-form-group>

        <b-btn
          variant="primary"
          class="w-full h-[60px] !font-[700] mt-[12px]"
          type="submit"
          :disabled="loading || $validator.errors.any()"
        >
          {{ update ? 'Update Payment Method' : 'Add Payment Method' }}
          <b-spinner
            v-if="loading"
            class="ml-3"
            variant="light"
            small
          />
        </b-btn>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import {VueMaskDirective} from 'v-mask'
import {mapState} from 'vuex'
import CountrySelect from '@/layouts/dashboard/compontens/account/general/components/CountrySelect.vue'
import StripeElement from '@/components/stripe/Element.vue'
import StripeElements from '@/components/stripe/Elements.vue'

const defaultState = {
  number: '',
  exp_month: '',
  exp_year: '',
  cvc: '',
  name: '',
  country: '',
  zip_code: '',
  main: false
}

export default {
  name: 'AddMethodModal',
  components: {StripeElements, StripeElement, CountrySelect},
  directives: {
    mask: VueMaskDirective
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    update: {
      type: Boolean,
      default: false
    },
    setPrimary: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      card: null,
      expMonthsOptions: [
        {
          value: 1,
          label: 'Jan'
        },
        {
          value: 2,
          label: 'Feb'
        },
        {
          value: 3,
          label: 'Mar'
        },
        {
          value: 4,
          label: 'Apr'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'Jun'
        },
        {
          value: 7,
          label: 'Jul'
        },
        {
          value: 8,
          label: 'Aug'
        },
        {
          value: 9,
          label: 'Sep'
        },
        {
          value: 10,
          label: 'Oct'
        },
        {
          value: 11,
          label: 'Nov'
        },
        {
          value: 12,
          label: 'Dec'
        }
      ]
    }
  },
  computed: {
    ...mapState('subscription', {
      stripe: state => state.stripe
    }),
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    modal (val) {
      if (val) this.onOpen()
    }
  },
  methods: {
    onOpen () {
      const template = JSON.parse(JSON.stringify(defaultState))
      Object.keys(this.form).forEach(key => this.form[key] = template[key])
    },
    expYearsOptions (endYear) {
      let startYear = new Date().getFullYear()
      const endDate = endYear || new Date().getFullYear()
      let years = []

      while (startYear <= endDate) {
        years.push(startYear)
        startYear++
      }
      return years
    },
    async createToken () {
      const token = await this.stripe.createToken(this.card, {
        name: this.form.name,
        address_country: this.form.country,
        address_zip: this.form.zip_code
      })

      if (token.error) {
        console.error(token.error)
        this.$swal({
          icon: 'error',
          title: 'Payment Declined.',
          text: token.error.message,
          showConfirmButton: false
        })
      } else {
        if (token.token.id) {
          return token.token.id
        }
      }
    },
    async submit () {
      this.$validator.validateAll()
        .then(async (valid) => {
          if (valid) {
            this.loading = true

            const token = await this.createToken()
            if (!token) {
              this.loading = false
              return
            }

            await axios.post('api/user/settings/payment-methods', {
              token: token,
              main: this.setPrimary ? true : this.form.main
            })
              .then(() => {
                this.modal = false
                this.$emit('added')

                this.$swal({
                  icon: 'success',
                  iconColor: '#4F83E3',
                  toast: true,
                  position: 'top-right',
                  title: 'Payment method has been successfully added.',
                  showConfirmButton: false,
                  timer: 3000
                })
              })
              .catch(error => {
                this.$swal({
                  icon: 'warning',
                  title: error.response.data.message,
                  showConfirmButton: false
                })
              })
              .finally(() => {
                this.loading = false
              })

            this.$emit('submit', token)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.add-method-trigger {
  height: 254px;
  background: #FBFCFF;
  border: 1px solid #C2D8FF;
  box-sizing: border-box;
  box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.04);
  border-radius: 7px;
  transition: .5s;

  &:hover {
    box-shadow: none;
  }
}

.new-method-form {
  legend {
    font-size: 16px;
    font-weight: normal !important;
    color: #000 !important;
  }

  input,
  .custom-select, .form-control {
    border-radius: 2px;
  }

  .expire-date {
    display: flex;
    align-items: center;
  }

  .date-divided-control {
    input:focus {
      border-color: #E2E5EC !important;
    }

    &.is-invalid {
      .form-control {
        border-color: #dc3545 !important;
      }
    }
  }
}
</style>